/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Schema from 'docs/components/apis/Schema.vue';

/**
 * This component is used to nicely display API route parameters.
 *
 * @vue-prop {Object[]} [params] a list of parameters objects
 * @vue-prop {Object[]} [definitions] a list of definition objects
 *
 * @category docs.components.apis
 * @exports Parameters
 * @component
 */
const __vue_script__ = {
    name: 'Parameters',

    components: { Schema },

    props: {
        params: {
            type: Array,
            default: () => []
        },

        definitions: {
            type: Object,
            default: () => {}
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parameters"},[_c('h4',[_vm._v(_vm._s(_vm.$t('api_docs.params.title')))]),(!_vm.params.length)?_c('p',[_vm._v(_vm._s(_vm.$t('api_docs.params.none')))]):_c('div',{staticClass:"table-wrapper params"},[_c('table',{staticClass:"table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.params.key')))]),_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.params.value')))])])]),_c('tbody',_vm._l((_vm.params),function(param){return _c('tr',{staticClass:"param"},[_c('td',{staticClass:"key"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(param.name)),(param.required)?_c('span',{staticClass:"required"},[_vm._v(_vm._s(_vm.$t('api_docs.params.required')))]):_vm._e()]),_c('div',{staticClass:"what"},[(param.schema)?_c('span',[_vm._v(_vm._s(param.schema.type))]):_vm._e(),(param.type)?_c('span',[_vm._v(_vm._s(param.type))]):_vm._e()]),(param.enum)?_c('div',{staticClass:"enum"},[_c('small',[_vm._v("enum("+_vm._s(param.enum.join(', '))+")")])]):_vm._e(),_c('div',{staticClass:"where"},[_vm._v("("+_vm._s(param.in)+")")])]),_c('td',{staticClass:"value"},[(param.schema)?_c('schema',{attrs:{"schema":param.schema,"definitions":_vm.definitions}},[_c('vue-markdown',{staticClass:"desc"},[_vm._v(_vm._s(param.description))])],1):_c('vue-markdown',{staticClass:"desc"},[_vm._v(_vm._s(param.description))])],1)])}),0)])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Parameters.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__